import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const redeem_InvoiceApi = createAsyncThunk("redeem_Invoice", async () => {
  const response = await axiosInstance.get("/redeem_Invoice");
  return response.data;
});

const redeem_InvoiceSlice = createSlice({
  name: "redeem_Invoice",
  initialState: {
    redeem_Invoice: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(redeem_InvoiceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(redeem_InvoiceApi.fulfilled, (state, action) => {
        state.redeem_Invoice = action.payload;
        state.loading = false;
      })
      .addCase(redeem_InvoiceApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default redeem_InvoiceSlice.reducer;
